<template>
  <div class="servico-block w-full md:w-6 xl:w-4">
    <div :class="'inner-box ' + (itemIndex % 3  == 0 || itemIndex % 3 == 1 ? 'fade-in-left-small' : 'fade-in-right-small')">
      <div class="icon-box"><i :class="'icon ' + item.icone"></i></div>
      <div class="titulo" v-html="item.titulo"></div>
      <div class="descricao" v-html="item.descricao"></div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {};
  },
  props: {
    item: Object,
    itemIndex: Number,
  },
  computed: {},
  watch: {},
  methods: {},
  created() {},
  mounted() {},
  unmounted() {},
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->

<style scoped>
.servico-block {
  position: relative;
  padding: 0 11px;
  margin-bottom: 40px;
}
.servico-block .inner-box {
  height: 100%;
  padding: 60px 40px;
  background-color: #ffffff;
  text-align: center;
  outline: 1px solid transparent;
  outline-offset: -1px;
  transition: all 500ms ease;
  box-shadow: 0 15px 46px rgba(0, 0, 0, .1);
}
.servico-block .inner-box:hover {
  outline-color: #a9172b;
  outline-offset: -6px;
}
.servico-block .inner-box:hover .icon-box {
  transform: scale(1.1) translateY(-4px);
}
.titulo {
  display: block;
  font-size: 20px;
  font-weight: 500;
  line-height: 1.2em;
  color: #202020;
  margin-bottom: 25px;
}
.descricao {
  position: relative;
  font-weight: 400;
  font-size: 14px;
  line-height: 27px;
  color: #888888;
  margin-bottom: 30px;
}
.servico-block .icon-box {
  position: relative;
  top: 0px;
  height: 80px;
  width: 80px;
  line-height: 80px;
  font-size: 70px;
  color: #a9172b;
  margin: 0 auto 30px;
  transition: all 500ms ease;
}
</style>
